module.exports = __webpack_public_path__ + "img/guihua-2.680ac676.jpg";